const { REACT_APP_SERVER_URL } = process.env;

const environment = {
  SERVER_URL: REACT_APP_SERVER_URL
};

export const urls = {
  URL_SEPARATOR: "/",

  LOGIN_URL: environment.SERVER_URL + "/login",
  LOGOUT_URL: environment.SERVER_URL + "/logout",
  REGISTER_URL: environment.SERVER_URL + "/register",
  PASSWORD_REQUIREMENTS_URL: environment.SERVER_URL + "/passwordRequirements",
  CHECK_USERNAME_URL: environment.SERVER_URL + "/checkUsername",
  CHECK_EMAIL_URL: environment.SERVER_URL + "/checkEmail",

  USERS_URL: environment.SERVER_URL + "/users",
  SYSTEM_PROCESSES_URL: "/systemProcesses",

  CLASSIFICATION_TYPES_URL: environment.SERVER_URL + "/classificationTypes",
  CLASSIFICATION_STATUSES_URL:
    environment.SERVER_URL + "/classificationStatuses",
  CLASSIFICATIONS_URL: environment.SERVER_URL + "/classifications",

  MODELS_URL: environment.SERVER_URL + "/models",
  ENTITIES_URL: environment.SERVER_URL + "/entities",
  KNOWLEDGES_URL: environment.SERVER_URL + "/knowledges",
  KNOWLEDGE_TYPES_URL: environment.SERVER_URL + "/knowledgeTypes",
  KNOWLEDGE_COPYRIGHTS_URL: environment.SERVER_URL + "/knowledgeCopyrights",
  KNOWLEDGE_SOURCES_URL: environment.SERVER_URL + "/knowledgeSources",
  LIFE_CYCLES_URL: environment.SERVER_URL + "/lifeCycles",
  DOCUMENTS_URL: environment.SERVER_URL + "/documents",
  ENTITY_RATINGS_URL: environment.SERVER_URL + "/entityRatings",
  ENTITY_MESSAGE_LOGS: environment.SERVER_URL + "/generalEntityMessageLogs",
  ENTITY_MESSAGE_LOG_TYPES:
    environment.SERVER_URL + "/generalEntityMessageLogTypes",
  LIFE_CYCLE_STATE_TYPES_URL: environment.SERVER_URL + "/lifeCycleStateTypes",
  LIFE_CYCLE_CLASS_DEFINITION_URL:
    environment.SERVER_URL + "/lifeCycleClassDefinitions",
  INVOLVEMENT_ROLES: environment.SERVER_URL + "/involvementRoles",
  INVOLVEMENT_ROLE_TYPES: environment.SERVER_URL + "/involvementRoleTypes",
  PARTY_ROLES: environment.SERVER_URL + "/partyRoles",
  PARTY_ROLES_TYPES: environment.SERVER_URL + "/partyRoleTypes",
  PARTY_ROLE_TYPE_DISCRIMINATORS:
    environment.SERVER_URL + "/partyRoleTypeDiscriminators",
  EXTENSIONS_URL: environment.SERVER_URL + "/extensions",
  USERS_PARTY_URL: environment.SERVER_URL + "/users/parties",
  OPERATIONS_URL: environment.SERVER_URL + "/operations",
  LANGUAGES_URL: environment.SERVER_URL + "/languages",
  PARTIES_URL: environment.SERVER_URL + "/parties",
  USERS_PARTY_CLASSIFICATIONS_BY_OPERATION_URL:
    environment.SERVER_URL + "/users/parties/classifications",
  OPERATIONS_URL: environment.SERVER_URL + "/operations"
};
